import { useRouter } from "next/router";
import { useMemo } from "react";
import { WaitingStatus } from "repositories/FortuneTellerRepository";
import { FortuneTellerOrderBy, MenuTypeV2 } from "shared/types";

const PER_PAGE = 30;

const Context = {
  waiting: "waiting",
  repeatRate: "repeat_rate",
} as const;

const Title = {
  chat: {
    context: {
      waiting: "今すぐ占える待機中の占い師",
      repeat_rate: "おすすめの占い師ランキング",
    },
  },
  tel: {
    context: {
      waiting: "今すぐ占える待機中の電話占い師",
      repeat_rate: "おすすめの電話占い師ランキング",
    },
  },
  subscription: {
    context: {
      waiting: "",
      repeat_rate: "",
    },
  },
};

const Description = {
  chat: {
    context: {
      waiting: "待機中なら15分以内にメッセージが届きます",
      repeat_rate: "特に鑑定満足度の高いおすすめチャット占い師ランキング",
    },
  },
  tel: {
    context: {
      waiting: "待機中なら今すぐにお電話が可能です",
      repeat_rate: "特に鑑定満足度の高いおすすめ電話占い師ランキング",
    },
  },
  subscription: {
    context: {
      waiting: "",
      repeat_rate: "",
    },
  },
};

interface RequestParams {
  menuType: MenuTypeV2;
  waiting?: WaitingStatus;
  orderBy?: FortuneTellerOrderBy;
  shuffle?: boolean;
  page?: number;
  limit?: number;
}

interface UseFortuneTellerListContextReturn {
  reqParams: RequestParams;
  title: string;
  description: string;
  perPage: number;
}

const useFortuneTellerListContext = (): UseFortuneTellerListContextReturn => {
  const { query } = useRouter();
  const menuType = query.menuType as MenuTypeV2;
  const waitingStatus = query.waitingStatus as WaitingStatus;
  const orderBy = query.orderBy as FortuneTellerOrderBy;

  const context = useMemo(() => {
    if (waitingStatus === Context.waiting) {
      return Context.waiting;
    } else if (orderBy === Context.repeatRate) {
      return Context.repeatRate;
    }
  }, [orderBy, waitingStatus]);

  const reqParams = useMemo((): RequestParams => {
    return context === Context.waiting
      ? {
          menuType,
          waiting: Context.waiting,
          shuffle: query.shuffle === "true",
        }
      : {
          menuType,
          orderBy,
          shuffle: query.shuffle === "true",
          page: Number(query.page),
          limit: PER_PAGE,
        };
  }, [context, menuType, orderBy, query]);

  const title = Title[menuType]?.context[context] ?? "新登場占い師";
  const description =
    Description[menuType]?.context[context] ??
    "MIRORに登録された新規占い師一覧";

  return {
    reqParams,
    title,
    description,
    perPage: PER_PAGE,
  };
};

export default useFortuneTellerListContext;
